import initPage from 'init-page';
import Swupjs from 'swupjs';
import swupGa from 'swup-ga-plugin';
import swupMergeHead from 'swup-merge-head-plugin';
import setFocus from 'set-focus';
import transitionEnd from 'transition-end';
import vars from 'variables';
import { reset } from 'product-icon';
import { $, $$ } from 'query-selector';

// TO DO:
// - Refactor anim structure, easings

export default () => {
  if (vars.browser.legacy || vars.browser.reducedMotion) return;

  function fadeOut(el) {
    el.style.setProperty('transition', `opacity 200ms ${vars.ease.fade}`);
    el.style.setProperty('opacity', '0');
    return transitionEnd(el, 'opacity');
  }

  function fadeIn(el, force = true) {
    if (force) {
      el.style.setProperty('opacity', '0');
      const forceLayout = el.offsetWidth;
    }

    el.style.setProperty('opacity', '1');
    el.style.setProperty('transition', `opacity 200ms ${vars.ease.fade}`);
    return transitionEnd(el, 'opacity');
  }

  let headerVisible = false;

  function checkHeaderVisibility() {
    const logo = $('.js-header-logo');
    return logo.getBoundingClientRect().bottom > 0;
  }

  function handleAnimOut() {
    const anims = [];

    // Fade out header if not in viewport
    headerVisible = checkHeaderVisibility();

    if (!headerVisible) {
      const header = $('.js-header');
      anims.push(fadeOut(header));
    }

    // Fade out footer
    const footer = $('.js-footer');
    anims.push(fadeOut(footer));

    return anims;
  }

  async function handleAnimIn() {
    const anims = [];
    const header = $('.js-header');

    if (!headerVisible) {
      window.scroll(0, 0);
      anims.push(fadeIn(header, false));
    }

    const footer = $('.js-footer');
    anims.push(fadeIn(footer, false));

    // A11y
    setFocus($('main'));

    return anims;
  }

  // Which swup link is clicked – event listener below
  let link = null;
  let skipProductIntro = true;

  // Fade page in / out
  const defaultTransition = {
    out: async next => {
      const anims = [];
      const main = $('.js-main');
      anims.push(fadeOut(main));

      const otherAnims = handleAnimOut();

      await Promise.all(anims.concat(otherAnims));
      next();
    },
    in: async next => {
      const anims = [];
      const main = $('.js-main');
      anims.push(fadeIn(main));

      const otherAnims = handleAnimIn();

      await Promise.all(anims.concat(otherAnims));
      next();
    }
  };

  // Product slider
  const productSliderTransition = {
    out: async next => {
      const anims = [];

      // Fade out article
      const productArticle = $('.js-product-article');
      anims.push(fadeOut(productArticle));

      // Fade out links
      const nextLink = $('.js-product-next-link');
      const prevLink = $('.js-product-prev-link');
      anims.push(fadeOut(nextLink));
      anims.push(fadeOut(prevLink));

      // Get icons
      const heroIcon = $('.js-product-hero-icon');
      const nextIcon = $('.js-product-next-icon');
      const prevIcon = $('.js-product-prev-icon');

      // Reset icons
      reset(heroIcon, 400);
      reset(nextIcon, 400);
      reset(prevIcon, 400);

      // Get anim direction
      const toNext = link.classList.contains('js-product-next-link');

      // Get icon positions / scales
      let heroRect = heroIcon.getBoundingClientRect();
      let nextRect = nextIcon.getBoundingClientRect();
      let prevRect = prevIcon.getBoundingClientRect();

      const newHeroScale = nextRect.width / heroRect.width;
      const newPrevScale = toNext ? 1 : heroRect.width / prevRect.width;
      const newNextScale = toNext ? heroRect.width / nextRect.width : 1;

      let newHeroX = 0;
      let newNextX = 0;
      let newPrevX = 0;

      if (!toNext) newHeroX = nextRect.left + nextRect.width / 2;
      else newHeroX = prevRect.left + prevRect.width / 2;
      newHeroX -= heroRect.left + heroRect.width / 2;
      newHeroX /= newHeroScale;

      if (toNext) {
        newNextX = heroRect.left + heroRect.width / 2;
        newNextX -= nextRect.left + nextRect.width / 2;

        newPrevX = nextRect.left + nextRect.width / 2;
        newPrevX -= prevRect.left + prevRect.width / 2;
      } else {
        newNextX = prevRect.left + prevRect.width / 2;
        newNextX -= nextRect.left + nextRect.width / 2;

        newPrevX = heroRect.left + heroRect.width / 2;
        newPrevX -= prevRect.left + prevRect.width / 2;
      }

      newNextX /= newNextScale;
      newPrevX /= newPrevScale;

      // Animate to new positions / scales
      heroIcon.style.setProperty(
        'transform',
        `scale(${newHeroScale}) translateX(${newHeroX}px)`
      );
      heroIcon.style.setProperty('transition', `transform 400ms ease-out`);

      anims.push(transitionEnd(heroIcon, 'transform'));

      if (toNext) {
        nextIcon.style.setProperty(
          'transform',
          `scale(${newNextScale}) translateX(${newNextX}px)`
        );

        nextIcon.style.setProperty('transition', `transform 400ms ease-out`);

        anims.push(transitionEnd(nextIcon, 'transform'));

        // First move out of viewport
        prevIcon.style.setProperty('transform', `translateX(-50%)`);
        prevIcon.style.setProperty('transition', `transform 200ms ease-out`);

        await transitionEnd(prevIcon, 'transform');

        // Then move in at other side
        prevIcon.style.setProperty(
          'transform',
          `translateX(${newPrevX + prevRect.width / 2}px)`
        );
        prevIcon.style.removeProperty('transition');
        const forceLayout = prevIcon.offsetWidth;

        prevIcon.style.setProperty('transform', `translateX(${newPrevX}px)`);
        prevIcon.style.setProperty('transition', `transform 200ms ease-out`);

        anims.push(transitionEnd(prevIcon, 'transform'));
      } else {
        prevIcon.style.setProperty(
          'transform',
          `scale(${newPrevScale}) translateX(${newPrevX}px)`
        );

        prevIcon.style.setProperty('transition', `transform 400ms ease-out`);

        anims.push(transitionEnd(prevIcon, 'transform'));

        // First move out of viewport
        nextIcon.style.setProperty('transform', `translateX(50%)`);
        nextIcon.style.setProperty('transition', `transform 200ms ease-out`);

        await transitionEnd(nextIcon, 'transform');

        // Then move in at other side
        nextIcon.style.setProperty(
          'transform',
          `translateX(${newNextX - nextRect.width / 2}px)`
        );
        nextIcon.style.removeProperty('transition');
        const forceLayout = nextIcon.offsetWidth;

        nextIcon.style.setProperty('transform', `translateX(${newNextX}px)`);
        nextIcon.style.setProperty('transition', `transform 200ms ease-out`);

        anims.push(transitionEnd(nextIcon, 'transform'));
      }

      await Promise.all(anims);
      next();
    },
    in: async next => {
      const anims = [];

      // Fade out article
      const productArticle = $('.js-product-article');
      anims.push(fadeIn(productArticle));

      // Fade out links
      const nextLink = $('.js-product-next-link');
      const prevLink = $('.js-product-prev-link');
      anims.push(fadeIn(nextLink));
      anims.push(fadeIn(prevLink));

      // A11y
      setFocus($('main'));

      await Promise.all(anims);
      next();
    }
  };

  const animations = {
    '*': defaultTransition,
    '*>product-slider': productSliderTransition
  };

  // Init swup and plugins
  const plugins = [swupMergeHead];
  // Only add GA plugin if it is enabled
  if ($('meta[name="analytics"]')) plugins.push(swupGa);

  const swup = new Swupjs({
    LINK_SELECTOR:
      'a[href^="' +
      window.location.origin +
      '"]:not([hreflang]):not([download]), a[href^="/"]:not([hreflang]):not([download])',
    FORM_SELECTOR: 'form[data-swup-form]',
    elements: ['.js-main', '.js-nav-wrapper a', '.js-footer nav a'],
    animations: animations,
    //animationSelector: '[class*="transition-"]',
    cache: false, // lazyload problem -> current page html is cached, not original state
    pageClassPrefix: '',
    scroll: false,
    debugMode: false,
    preload: true,
    support: true,
    skipPopStateHandling: event => {
      // disable for better browser back button behaviour
      // if (event.state && event.state.source == 'swup') {
      //   return false;
      // }
      // return true;
    },
    animateHistoryBrowsing: false,
    plugins: plugins
  });

  // Set link for anims
  swup.on('clickLink', e => {
    link = e.delegateTarget;

    if (link.dataset.skipIntro === 'true') {
      skipProductIntro = true;
    } else {
      skipProductIntro = false;
    }
  });

  // Add progress bar
  const progressBar = $('.js-progress-bar');

  swup.on('clickLink', () => {
    progressBar.removeAttribute('style');
    const forceLayout = progressBar.offsetWidth;

    progressBar.style.setProperty('transform', 'scaleX(0.66)');
    progressBar.style.setProperty('transition', `transform 400ms ease-out`);
  });

  swup.on('contentReplaced', async () => {
    progressBar.style.setProperty('transform', 'scaleX(1)');

    await transitionEnd(progressBar, 'transform');
    progressBar.style.setProperty('transform', 'scaleY(0)');
    progressBar.style.setProperty('transition', `transform 200ms ease-out`);
  });

  // if same page reset progressbar
  swup.on('samePage', () => {
    progressBar.removeAttribute('style');
  });

  // browser back button
  swup.on('popState', e => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  });

  // init page specific modules
  swup.on('contentReplaced', () => {
    initPage(skipProductIntro);
  });
};
